// Spinner shown inside the submit button while a request is in flight.
const Spinner = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
    className={`${className} animate-spin`}
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M12 21a9 9 0 1 1 6.18-15.55a.75.75 0 0 1 0 1.06a.74.74 0 0 1-1.06 0A7.51 7.51 0 1 0 19.5 12a.75.75 0 0 1 1.5 0a9 9 0 0 1-9 9Z"
      className="fill-white stroke-white"
    />
  </svg>
);

export default Spinner;
